// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] || chunkId) + "-" + {"279":"903d0ae8b80358bf4721","415":"ea964fc2df8766cf49b9","522":"ad8e834f0dd4eb090f7d"}[chunkId] + ".js";
};